// import aesEcb from 'aes-ecb';
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';

export const rsaEncrypt = (data) => {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(`MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnASt2BKIac4sRD/zG0Qf
rBpM/jSEOuq/ftELFLP4HpYQBcNxFGcMmTIWcPOo/Q7igiAWtuJT+hhsbeIFJR9L
C/0uY77VmIOu0+H+H6Ae4XIKhGEXVIYMpeP81kxki07q4/1mul7ndCviRnnVxwoP
U4FLGyvsIEU4z1DfBTG+KdA6v1KY9LJM2U72rOQ50DLJgs6c9GWjlJ7dM3gtcF9O
2nMWlCoMKR3pBuCQrvgjgRk2+lnJZruxAobTNVf5Zt+EVSqdJQ22PTKRAVXi5Sec
HOUgKszLmkAwjuk3TdfuchA/ovdGXUJlVRxFg748MpPmlrN7kGKApH0P04jq1V9p
ywIDAQAB`);
    return encrypt.encrypt(data);
}

export const rsaDecrypt = (data) => {
    const encrypt = new JSEncrypt();
    encrypt.setPrivateKey(`MIIEowIBAAKCAQEAnASt2BKIac4sRD/zG0QfrBpM/jSEOuq/ftELFLP4HpYQBcNx
FGcMmTIWcPOo/Q7igiAWtuJT+hhsbeIFJR9LC/0uY77VmIOu0+H+H6Ae4XIKhGEX
VIYMpeP81kxki07q4/1mul7ndCviRnnVxwoPU4FLGyvsIEU4z1DfBTG+KdA6v1KY
9LJM2U72rOQ50DLJgs6c9GWjlJ7dM3gtcF9O2nMWlCoMKR3pBuCQrvgjgRk2+lnJ
ZruxAobTNVf5Zt+EVSqdJQ22PTKRAVXi5SecHOUgKszLmkAwjuk3TdfuchA/ovdG
XUJlVRxFg748MpPmlrN7kGKApH0P04jq1V9pywIDAQABAoIBAEEVGJnifUI5zbB4
xsZQgC/QVt7R9HkJVPGnbUppGq9TpQJqeYDrzc8YHFFo600JCQcEMMWAm0xgJNcf
qkrGh41MQ647PKnfAK6FfvcdWdRsuKNpRwys0JjhBqc0fdq5BHYvzksfbMjCx6Tj
jQB3G1aXwEdo5pq9lYmx8B6gFfYlrfMABc5p7zpBklyl9vK+/wM8Rbre4akwBxve
hGi++bR2Edm6wKZxfRkgT+5B7y2o+JzaXru5v9kaNWfxayTLgrUyBGeovkYGl6Ts
HrvgGoayEBReTJ31QjYLNmAFIlQN2UuxV1FQsWrMFF/ZABeV0Oxa7cfOqCL/pv38
QVk6XxkCgYEAtk7UcFnIxRber7RM4YmY8RNNDdy1CTxhI+I6+4aonzNYR35jaZnf
TpJngs2O68VhZE4WRMBVAeVrSP3931cTGgmBHQ9VqHvk0kRM6JDS22bjWF9lYPWp
/pVddhFflU//9S2x56mxW3AubQFVFSb7+mctg8CzQ42e9Ovba/AdqyMCgYEA2xVn
aQ8Hf60xf9KyRTVit3eW3NFZujIrbt1OSorucyDrZUluklRrBrKxgBkoGutKd3RP
Dv+u4WQPB4eW+hYHYrCjObd/BInPB1juN/DBQpCJJlXBN+C4JdYK7xNuktBl1nz7
JAeAXRzqvp+CxL65e7/eC5mcufLU90EvygJ65TkCgYEAnGpUILUX6emuVCgo0lVB
MI2zzdHwTaVNXwFKQ+YMJNNjyatp1f/cNUitoO+G0Uj/P5Uzy/cMuFzDSNQLDqVh
0TQYX/t5Ld5mu/U3203ua6oCIx9uFtuP58r1bkiHrs79t7ll63KPpflBC+tZuZVC
GlyOE32xEKOgn1kBYMGaYusCgYAKrxSH7w+yjkOntCK1dVEHGXHl+t+hUOkFUw2K
XRQb0TMpkVcvE6bUgMpfMNrf1TGgea+RT667lyGUgGxAbeqWSX7sRaKQGhhah1+2
oqsKD/pgQDZX/0F7tuB5oDz4M+mDeDzXGPaNk+duvGCoL5TkEAtIDYmzF8CC/k7S
TySnIQKBgATuzl+4XRAQLBO5Ot1OWO9Cunnb9Z1rTb6DSngzUcQ2eikiKSGIB8cR
U8LY9j7e+yU2uJbqoySnkYyOow9OMrPlwsoE1RRUnXoTVEa4ttz+7d1C+mQK14F/
9q4SKDMnSNeNKo1Qy4mpkFbx5Z4DOjNXj3N46kM5tAyJzCPLk6ZK`);
    return encrypt.decrypt(data);
}

// export const aesEncryped = (secretKey, iv, payload) => {
//     // const paddedData = CryptoJS.pad.Pkcs7.pad(CryptoJS.enc.Utf8.parse(data), 32);
//     // return CryptoJS.AES.encrypt(paddedData, CryptoJS.enc.Hex.parse(key), { mode: CryptoJS.mode.ECB }).ciphertext.toString(CryptoJS.enc.Base64);

//     // Convert the secret key to a format suitable for encryption
//     const derived_key = CryptoJS.enc.Base64.parse(secretKey);

//     // Initialize the initialization vector (IV) and encryption mode
//     const derived_iv = CryptoJS.enc.Utf8.parse(iv);
//     const encryptionOptions = {
//         iv: derived_iv,
//         mode: CryptoJS.mode.CBC
//     };

//     return CryptoJS.AES.encrypt(payload, derived_key, encryptionOptions).toString();
// }

// export const aesDecrypted = (secretKey, iv, encryptPayload) => {
//     return CryptoJS.AES.decrypt(encryptPayload, CryptoJS.enc.Base64.parse(secretKey), { mode: CryptoJS.mode.CBC, iv: CryptoJS.enc.Utf8.parse(iv) }).toString(CryptoJS.enc.Utf8);
// }


export const aesEncryped = (secretKey, iv, payload) => {
    // secretKey is a 32-char string (UUID hex without dashes); treat as 32-byte UTF‑8 for AES-256
    const derived_key = CryptoJS.enc.Utf8.parse(secretKey);

    // iv is base64; parse to 16 bytes
    const derived_iv = CryptoJS.enc.Base64.parse(iv);

    const encryptionOptions = {
        iv: derived_iv,
        mode: CryptoJS.mode.CBC
    };

    return CryptoJS.AES.encrypt(payload, derived_key, encryptionOptions).toString();
}

export const aesDecrypted = (secretKey, iv, encryptPayload) => {
    return CryptoJS.AES.decrypt(
        encryptPayload,
        CryptoJS.enc.Utf8.parse(secretKey),
        { mode: CryptoJS.mode.CBC, iv: CryptoJS.enc.Base64.parse(iv) }
    ).toString(CryptoJS.enc.Utf8);
}

export const ivGenerator = () => {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    const iv = CryptoJS.lib.WordArray.create(array).toString(CryptoJS.enc.Base64);
    return iv;
}
